export default [{
    layout: {
        logoDashboard: {
            style: {
                background: "url('/images/oxxo-gas-logo2.png') no-repeat center center",
                backgroundSize: "150px",
            }
        },
        logoLogin: {
            style: {
                background: "url('/images/profuturo-logo2.png') no-repeat center center",
                backgroundSize: "100px",
            }
        },
        landingImage: "/images/landing-honda.png"
    },
    filters: {
        clusters: { enabled: true, name: 'Segmentos' },
        date: { enabled: true, name: 'date' },
        logicalLocations: { enabled: true, name: 'Centros' },
        geoLocations: { enabled: true, name: 'Área' },
        criticalMoments: { enabled: false, name: 'Momento Critico' }
    },
    dashboard: [{
        id: 1,
        widgets: [
            {
                type: 'gauge',
                name: 'satisfaccionGeneral',
                apiUrl: 'indicators/satisfaction/values',
                //cardTitle: 'Satisfacción General',
                title: 'Satisfacción General',
                size: { xl: 6, xg: 6, lg: 6 },
                color: '#FF9902',
                historic: {
                    type: 'social-chart',
                    name: 'satisfaccionGeneralHist',
                    apiUrl: 'indicators/satisfaction/values',
                    groupBy: 'month',
                    title: 'Últimos 3 meses',
                    color: '#d0d00a'
                }
            },
            {
                type: 'gauge',
                name: 'atencionRepresentante',
                //cardTitle: 'Atención Representante Servicio al Cliente',
                title: 'Atención Representante Servicio al Cliente',
                apiUrl: 'indicators/willingness-to-return/values',
                color: '#FF9902',
                size: { xl: 6, xg: 6, lg: 6 },
                historic: {
                    type: 'social-chart',
                    name: 'atencionRepresentanteHist',
                    apiUrl: 'indicators/willingness-to-return/values',
                    groupBy: 'month',
                    title: 'Últimos 3 meses',
                    color: '#d0d00a'
                }
            },
            {
                type: 'gauge',
                name: 'disposicionRecomendar',
                //cardTitle: 'Disposición a Recomendar',
                title: 'Disposición a Recomendar',
                apiUrl: 'indicators/willingness-to-recommend/values',
                color: '#FF9902',
                size: { xl: 6, xg: 6, lg: 6 },
                historic: {
                    type: 'social-chart',
                    name: 'disposicionRecomendarHist',
                    apiUrl: 'indicators/willingness-to-recommend/values',
                    groupBy: 'month',
                    title: 'Últimos 3 meses',
                    color: '#d0d00a'
                }
            },
            {
                type: 'gauge',
                name: 'satisfaccionCarga',
                //cardTitle: 'Satisfacción carga de combustible',
                title: 'Satisfacción carga de combustible',
                apiUrl: 'indicators/willingness-to-recommend/values',
                color: '#FF9902',
                size: { xl: 6, xg: 6, lg: 6 },
                historic: {
                    type: 'social-chart',
                    name: 'satisfaccionCargaHist',
                    apiUrl: 'indicators/willingness-to-recommend/values',
                    groupBy: 'month',
                    title: 'Últimos 3 meses',
                    color: '#d0d00a'
                }
            }]
    },
    {
        id: 2,
        widgets: [
            {
                type: 'info-box',
                name: 'price',
                apiUrl: 'indicators/service/values',
                title: 'Precio',
                size: { xl: 6, xg: 6, lg: 6 },
                color: '#9F0001',
            },
            {
                type: 'info-box',
                name: 'atencion',
                apiUrl: 'indicators/food/values',
                title: 'Atención',
                size: { xl: 6, xg: 6, lg: 6 },
                color: '#9F0001',
            },
            {
                type: 'info-box',
                name: 'service',
                apiUrl: 'indicators/environment/values',
                title: 'Servicios',
                size: { xl: 6, xg: 6, lg: 6 },
                color: '#9F0001',
            },
            {
                type: 'info-box',
                name: 'rapidez',
                apiUrl: 'indicators/environment/values',
                title: 'Rapidez',
                size: { xl: 6, xg: 6, lg: 6 },
                color: '#9F0001',
            }]
    },
    {
        id: 3,
        widgets: [
            {
                type: 'stacked-bar',
                cardTitle: 'Análisis de Sentimientos',
                name: 'sentimentAnalysis',
                singleton: false,
                groupBy: 'tag',
                apiUrl: 'indicators/sentiment/values',
                color: ['#CEDC00', '#999999', '#e5525d'],
                sets: ['Positivo', 'Neutro', 'Negativo'],
                size: { xl: 10, xg: 10, lg: 10 }
            }, {
                type: 'text-analysis',
                cardTitle: 'Comentarios de Análisis de Sentimientos',
                name: 'sentimentCommentsAnalysis',
                singleton: false,
                groupBy: 'tag',
                apiUrl: 'indicators/sentiment/values',
                sets: ['Positivo', 'Neutro', 'Negativo'],
                size: { xl: 14, xg: 14, lg: 14 },
                subQuery: {
                    name: 'sentimentComments',
                    tag: 'tag',
                    singleton: false,
                    apiUrl: 'indicators/sentiment-comments/values'
                }
            }]
    },
    {
        id: 4,
        widgets: [
            {
                type: 'comments-list',
                cardTitle: 'Últimos comentarios',
                name: 'lastComments',
                singleton: false,
                apiUrl: 'indicators/comments/values',
                color: '#d0d00a',
                size: { xl: 24, xg: 24, lg: 24 }
            }]
    }]
}]




// WEBPACK FOOTER //
// ./src/config/configurations.js